'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('forum-overview', {
      url: '/forum',
      template: '<forum-overview></forum-overview>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/forum/overview/overview.routes.js